import {useContext} from 'react';

import {UserContext} from '../../../../contexts/UserContext/UserContext';
import {useTrackingEvents} from '../../../../hooks/useTrackingEvents';
import {ROLE_COMPANY_ADMIN} from '../../../../lib/constants';
import CookieService from '../../../../services/CookieService';
import {TrackingEvents} from '../../../../types/TrackingEvents';
import {User} from '../../../../types/User';

/**
 *
 * Writes the session and fires the login tracking events. Shared by the plain sign-in path and the
 * two-factor path, so a user who has to enter an OTP is logged in exactly like everyone else.
 */
export const useCompleteLogin = () => {
  const {userContextLogin} = useContext(UserContext);
  const {Version, Action, Category} = TrackingEvents;

  const {dispatchTracking, identifyUser} = useTrackingEvents({version: Version.v1, action: Action.UserLoggedIn});

  const completeLogin = (user: User) => {
    CookieService.setCookie(user);
    userContextLogin(user);

    const category = user.role.type === ROLE_COMPANY_ADMIN ? Category.Company : Category.Applicant;

    dispatchTracking({category});
    identifyUser(user.id);
  };

  return {completeLogin};
};
